import { ReactElement } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { Checkbox } from '@hopskipdrive/react-components';

import { StyledCheckboxField, StyledFormLabel } from '../IncidentForm.styles';

interface IncidentReportField {
  defaultValue?: boolean;
}

export const IncidentReportField = ({ defaultValue }: IncidentReportField): ReactElement => {
  const { control } = useFormContext();
  const { field } = useController({
    name: 'incidentReportFiled',
    control,
    defaultValue,
  });

  return (
    <StyledCheckboxField display="flex" alignItems="center">
      <Checkbox
        name="incidentReport-checkbox"
        id="incidentReport-checkbox"
        checked={field.value}
        onClick={() => field.onChange(!field.value)}
      />
      <StyledFormLabel htmlFor="incidentReport-checkbox">Client report created</StyledFormLabel>
    </StyledCheckboxField>
  );
};
